import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AddProviderCallCostState, addProviderCallCostFeatureKey } from './add-provider-call-costs.reducer';

const getAddProviderCallCostFeature = createFeatureSelector<AddProviderCallCostState>(addProviderCallCostFeatureKey);

export const getAddProviderCallCostCallState = createSelector(getAddProviderCallCostFeature, (state) => {
   return state.callState;
});
